var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-item",style:(_vm.style),attrs:{"id":_vm.widget.object.wid}},[_c('div',{style:({ height: '100%', width: '100%' })},[_c('LinkViewer',{attrs:{"data":_vm.widget.object}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }